module.exports = __webpack_public_path__ + "static/Burst_3s-a45627f9c287b56a9175e55a0b90378b.jpg";